import { render } from "./EmergencyContact.vue?vue&type=template&id=37bf824e"
import script from "./EmergencyContact.vue?vue&type=script&lang=js"
export * from "./EmergencyContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__